import styled from 'styled-components'

export const Anchor = styled.a({
  '&:hover': {
    textDecoration: 'underline',
  },
  color: 'inherit',
})
